import connectionProxy from './connectionProxy'

// página pública do QR Code da FDS de um produto: o token substitui o id do produto
export const getProductFds = token =>
  connectionProxy.http.get(`/fds_por_produto/${token}`)



// WEBPACK FOOTER //
// ./src/api/productFds.js